import ReglaTipoTransaccionCreate from './ReglaTipoTransaccionCreate';

const indexReglaTipoTransaccion = {
    create: ReglaTipoTransaccionCreate,
};

export default indexReglaTipoTransaccion;
